/* SPDX-FileCopyrightText: Copyright (c) 2026 NVIDIA CORPORATION & AFFILIATES. All rights reserved. */
/* SPDX-License-Identifier: Apache-2.0 */

:host {
  --color: var(--nve-sys-interaction-color);
  display: block;
  width: fit-content;
}

[internal-host] {
  color: var(--color);
  display: flex;
  gap: var(--nve-ref-space-sm);
  flex-direction: column;
}

nve-menu {
  --width: 100%;
}
